import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';

export const LeadReports = () => (
  <>
    <DocumentHead title='Leads Report' />
    <PageTemplate main={<Main />} />
  </>
);
